<template>
    <div class="footer">
      <div class="container">
        <p>{{ $t('footer.copyright') }}</p>
      </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'Footer',
  setup() {
    const { t, locale } = useI18n()
    return {
      t,
      locale
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  padding: 20px 0;
  background-color: #fff;
  border-top: 1px solid #eee;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    color: #777;
    font-size: 12px;
    min-height: auto;
    background: none;
    padding: 0;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .footer {
    .container {
      padding:  0 30px;
    }
  }
}

@media (max-width: 480px) {
  .footer {
    .container {
      padding:  0 30px;
    }
  }
}
</style>